import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiUserContactChipGridInputComponent } from '@fi-shared/fi-user-contact-chip-grid-input/fi-user-contact-chip-grid-input.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [CommonModule, MatChipsModule, MatFormFieldModule, MatIconModule, MatButtonModule, SelectSearchModule],
    declarations: [FiUserContactChipGridInputComponent],
    exports: [FiUserContactChipGridInputComponent],
})
export class FiUserContactChipGridInputModule {}
